export default __webpack_public_path__ + "static/media/Testimonials.008a08f7.svg";